import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { footballTeamService } from "../../../../../commons";
import { FootballBasicStatistics } from "../../../../../commons/models/football/football-basic-statistics";

export interface IFootballTeamStatisticsState {
  teamStatistics: FootballBasicStatistics;
  teamStatisticsStatus: StatusEnum;
}

export interface IFootballTeamStatisticsOption {
  teamId: number;
  urlParams: {
    seasonId: number;
  };
}

const initialState: IFootballTeamStatisticsState = {
  teamStatistics: new FootballBasicStatistics(),
  teamStatisticsStatus: StatusEnum.Idle,
};

export const fetchTeamBasicStatistics = createAsyncThunk(
  "teams/fetchTeamBasicStatistics",
  async (options: IFootballTeamStatisticsOption, thunkAPI) => {
    try {
      const teamStatistics = await footballTeamService.getStatistics(options.teamId, options.urlParams);
      return teamStatistics;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballTeamStatisticsSlice = createSlice({
  name: "footballTeamStatistics",
  initialState: initialState,
  reducers: {
    cleanUpTeamStats(state) {
      state.teamStatistics = new FootballBasicStatistics();
      state.teamStatisticsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTeamBasicStatistics.pending, (state) => {
        state.teamStatisticsStatus = StatusEnum.Loading;
      })
      .addCase(fetchTeamBasicStatistics.fulfilled, (state, action: PayloadAction<FootballBasicStatistics>) => {
        state.teamStatisticsStatus = StatusEnum.Succeeded;
        state.teamStatistics = action.payload;
      })
      .addCase(fetchTeamBasicStatistics.rejected, (state) => {
        state.teamStatisticsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamStats } = footballTeamStatisticsSlice.actions;
export default footballTeamStatisticsSlice.reducer;
